<template>
  <v-layout row wrap align-start align-content-start class="asset-status-home">
    <!-- Title and Tabs -->
    <v-flex xs12>
      <v-toolbar tabs color="white" class="elevation-1">
        <v-icon class="mr-1 secondary--text">settings_input_component</v-icon>
        <v-toolbar-title class="secondary--text">Asset Status</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-flex>
    <v-flex xs12>
      <AssetStatusSearchFilter />
    </v-flex>
    <v-flex xs12>
      <AssetStatusSearchResult />
    </v-flex>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" color="error" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import AssetStatusSearchFilter from "@/AssetStatus/AssetStatusSearchFilter"
import AssetStatusSearchResult from "@/AssetStatus/AssetStatusSearchResult"
import messages from "@/AssetStatus/messages.json"
import AppService from "@/AppService"

export default {
  name: "AssetStatusHome",
  components: {
    AssetStatusSearchFilter,
    AssetStatusSearchResult
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: null,
        message: ""
      }
    }
  },
  methods: {},
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:assetStatusServerError", () => {
      this.snackbar.show = true
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/AssetStatus/AssetStatusHome.vue